import Vuex from "vuex";
import Vue from "vue";
import General from "./modules/general";
import Login from "./modules/login";
import Config from "./modules/config";
import ExumacaoTranslado from "./modules/exumacaotranslado";


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    namespaced: true,
    General,
    Login,
    Config,
    ExumacaoTranslado
  }
});

export default store;
